import styled from 'styled-components';
import { TABLET_WIDTH } from '~~elements/Const';

export const AvatarDisplay = styled.div`
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  background-image: url(${({ url }) => url});
  background-size: cover;
  background-position: center;
`;

export const ImageDisplay = styled.div`
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  background-image: url(${({ url }) => url});
  background-size: contain;
  background-repeat: no-repeat;
  background-position: center;
`;

const playerAvatarWidth = {
  l: '9rem',
  s: '8rem',
};
export const ImageWrapper = styled.div`
  width: ${playerAvatarWidth.l};
  height: calc(${playerAvatarWidth.l} * ${({ avatarRatio }) => avatarRatio});
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  button {
    align-self: center;
    position: relative;
  }

  @media (max-width: ${TABLET_WIDTH}) {
    width: ${playerAvatarWidth.s};
    height: calc(${playerAvatarWidth.s} * ${({ avatarRatio }) => avatarRatio});
  }
`;

export const ColumnWrapper = styled.div`
  width: 100%;
  display: flex;
  flex-wrap: wrap;
  gap: 0.5rem;
`;
